async function getItems() {
  var res = await theme.cart?.getCart()
}
getItems()

$(document).mouseup(function(e) {
    var multiVariPop = $(".upsell-variant-select")
    var container = $(".upsell-variant-one-select");
    var containerB = $(".upsell-add-btn[data-options='1']");
    // if the target of the click isn't the container nor a descendant of the container
    //console.log("e.target",e.target)
    if (!container.is(e.target) && container.has(e.target).length === 0 && !containerB.is(e.target) ) {
        container.addClass('hide')
        $(".upsell-add-btn[data-options='1']").text("Add to Cart")
    }
    if(containerB.is(e.target)) {
      multiVariPop.css('display','none')
    }
});

document.querySelectorAll('.upsell-show-options').forEach(el => {
  el.addEventListener('click', function () {
    var parent = this.closest('[main-prod-id]')
    var prodId = parent?.getAttribute('prod-id')
    var mainProdId = parent.getAttribute('main-prod-id')
    var dataOptions = this.getAttribute('data-options')

    if(dataOptions == 1) {
      const options = parent?.querySelectorAll(".pf-cupsell-option") || [];
      
      if(options.length == 1) {
        const optionId = options[0].querySelector("input")?.dataset?.variantId;

        if(optionId) {
          return theme.cart.addSingleItem(optionId, 1);
        }
      }

      setTimeout(() => {
        $('.upsell-variant-one-select').addClass('hide')
        var optCont = document.querySelector(`[main-prod-id='${mainProdId}'] .upsell-variant-one-select`)
        optCont.classList.remove('hide')
        if(prodId){
          $(this).text("Confirm")
        }
      },200)
    } else {
      $('.upsell-variant-select').css('display', 'none')
      var optCont = document.querySelector(`.upsell-variant-select[main-prod-id='${mainProdId}']`)
      optCont.style.display = 'block'
    }
  })
});

document.querySelectorAll('.upsell-variant-select .close').forEach(el => {
  el.addEventListener('click', function () {
    var parent = this.closest('[main-prod-id]')
    var mainProdId = parent.getAttribute('main-prod-id')
    parent.style.display = 'none'
  })
})
document.querySelectorAll('.upsell-variant-select select').forEach(el => {
  el.addEventListener('change', function () {
    var parent = this.closest('[prod-id]')
    var mainProdId = parent.getAttribute('main-prod-id')
    var prodId = parent.getAttribute('prod-id')
    var addBtn = parent.querySelector('.upsell-add-btn')

    var options = parent.querySelectorAll('select')
    options = [...options].map(el => el.value)

    mainProdId = parseInt(mainProdId)
    const prod = Window.allVariants[mainProdId]
    var fd = prod?.find(el => el.options.includes(options.join('')))
    if(prod){
      checkOtherOptions(prod, this, parent)
    }
    if(fd && fd?.available){
      addBtn.classList.remove('disabled')
      parent.setAttribute('prod-id', fd.id)
    } else {
      parent.setAttribute('prod-id', '')
      addBtn.classList.add('disabled')
    }
  })
})

function checkOtherOptions(prod, thisSelect, parent) {
  const val = thisSelect.value
  var allSelects = [...parent.querySelectorAll('select')]
  allSelects = allSelects.filter(el => el != thisSelect)
  allSelects.forEach(sel => {
    var allSelectsVal = allSelects.map(el => el.value && el != sel ? el.value : []).flat()
    //console.log("allSelectsVal", allSelectsVal)
    const options = sel.querySelectorAll('option')
    options.forEach(opt => {
      const optVal = opt.getAttribute('value')
      if(optVal){
        var exist = prod.find(el => [...allSelectsVal, val, optVal].every(thisVal => el.options.includes(thisVal)) && el.available)
        if(exist){
          opt.style.display = 'block'
        } else {
          opt.style.display = 'none'
          //console.log('optVal', optVal)
        }
      }
    })
  })
}

function hideNotValidOptions() {
  
}

document.querySelectorAll('.upsell-variant-one-select .one-select').forEach(el => {
  el.addEventListener('change', function () {
    var parent = this.closest('[prod-id]')
    var mainProdId = parent.getAttribute('main-prod-id')
    var prodId = parent.getAttribute('prod-id')
    var addBtn = parent.querySelector('.upsell-add-btn')

    var option = this.value

    mainProdId = parseInt(mainProdId)
    console.log("mainProdId",mainProdId)
    var fd = Window.allVariants[parseInt(mainProdId)].find(el => el.options.includes(option))
    if(fd && fd?.available){
      parent.setAttribute('prod-id', fd.id)
      $(addBtn).text("Confirm")
    } else {
      parent.setAttribute('prod-id', '')
    }
  })
})

document.querySelectorAll('.upsell-add-btn').forEach(el => {
  el.addEventListener('click', function () {
    var dataOptions = this.getAttribute('data-options')
    var parent = this.closest('[prod-id]')
    var prodId = parent.getAttribute('prod-id')
    var oneVariantSelect = parent.querySelector('.upsell-variant-one-select')
    //console.log("oneVariantSelect",oneVariantSelect)
    //console.log("oneVariantSelect?.hasClass('hide')", oneVariantSelect?.classList.contains('hide') )
    var addToCart = (prodId && dataOptions != 1) || (prodId && !oneVariantSelect?.classList.contains('hide'))
    console.log("addToCart",addToCart)
    if(addToCart){
      theme.cart.addSingleItem(prodId, 1);
      parent.style.display = 'none'
    }
  })
})



